'use strict';

var TagModel = require('./tag.model');
var TagCollection = Backbone.Collection.extend({
    model: TagModel,
});
var currentSearchSingletonModel = require('../../modules/models/current_search.singleton.model');

module.exports = Backbone.Model.extend({
    initialize: function() {
        var currentSearchModel = currentSearchSingletonModel.getInstance();
        this.listenTo(currentSearchModel, 'change', Odigeo._.bind(this.resetTags, this));
        this.listenTo(this.get('tagsActivated'), 'off', this.removeActivatedTag);
    },
    defaults: function() {
        return {
            tags: new TagCollection(),
            tagsActivated: new TagCollection(),
        };
    },
    resetTags: function() {
        var tagsActivated = this.get('tagsActivated');
        tagsActivated.remove(tagsActivated.models);
        this.get('tags').reset({silent: true});
    },
    setTag: function(model) {
        var tagCollection = this.get('tags');
        var tagsActivatedCollection = this.get('tagsActivated');
        var modelToUpdate = tagCollection.get(model.id);
        var silentOptions;
        var tag;

        if (modelToUpdate) {
            silentOptions = modelToUpdate.get('active') ? {silent: true} : {};
            modelToUpdate.set(model);
            if (model.active) {
                tagsActivatedCollection.remove(modelToUpdate, silentOptions);
                tagsActivatedCollection.push(modelToUpdate, silentOptions);
            }
        } else if (model.active) {
            tag = tagCollection.add(model);
            tagsActivatedCollection.push(tag);
        }
    },
    removeLastTag: function() {
        var tagsActivatedCollection = this.get('tagsActivated');
        if (tagsActivatedCollection.length > 0) {
            tagsActivatedCollection.pop().trigger('clear', this);
            this.trigger('lastTagRemoved');
        } else {
            Odigeo.trigger('flights-filters-summary:resetFiltersClicked');
        }
    },
    removeActivatedTag: function(model) {
        var tagsActivatedCollection = this.get('tagsActivated');
        tagsActivatedCollection.remove(model);
    },
});
